import { Fragment } from 'react';

import EditIcon from '@usas/ui-web/components/icons/EditIcon';
import DeleteIcon from '@usas/ui-web/components/icons/DeleteIcon';
import PlusIcon from '@usas/ui-web/components/icons/PlusIcon';

import { formatDateTimeTwelveHourClock, formatSubmittedDateTimeTwelveHourClock } from '@usas/ui-web/utils/DateFunctions';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const LargeDetailTableRow = ({ teamEntryMeetInfo, teamEntry, onView, onEdit, onDeleteTeamEntryClicked, onAdd }) => {
  return (
    <tr>
      <td>{teamEntry?.isReadOnly === true ? <a href='' onClick={(e) => onView(e, teamEntry)}>{teamEntry?.omeMeetName || ''}</a> : <span>{teamEntry?.omeMeetName || ''}</span>}</td>
      <td>{teamEntry?.meetEntryStartDate ? formatDateTimeTwelveHourClock(teamEntry?.meetEntryStartDate) : ''} {teamEntry?.meetEntryStartDate ? "-" : ''} {teamEntry?.meetEntryEndDate ? formatDateTimeTwelveHourClock(teamEntry?.meetEntryEndDate) : ''}</td>
      <td>{teamEntry?.timeZone || ''}</td>
      <td>{teamEntry?.teamEntryStatus || ''} {teamEntry?.orgUnitSubmissionDatetime ? '- ' + formatSubmittedDateTimeTwelveHourClock(teamEntry?.orgUnitSubmissionDatetime) + ' ' + teamEntry?.timeZone : ''}</td>
      <td>
        {teamEntry?.omeMeetOrgUnitEntryId > 0 ?
          <span>
            {(teamEntry?.teamEntryCurrentlyAllowed === true || teamEntry?.teamEntryChangesCurrentlyAllowed === true) &&
              <button className={global.IconButtonMargin} type="button" onClick={(e) => onEdit(e, teamEntry)}><EditIcon /></button>}
            {teamEntry?.teamEntryDeleteCurrentlyAllowed === true &&
              <button className={global.IconButtonMargin} type="button" onClick={(e) => onDeleteTeamEntryClicked(e, teamEntryMeetInfo, teamEntry)}><DeleteIcon /></button>}
          </span>
          :
          <Fragment>
            {teamEntry?.teamEntryCurrentlyAllowed === true &&
              <button className={global.IconButtonMargin} type="button" onClick={(e) => onAdd(e, teamEntryMeetInfo, teamEntry)}><PlusIcon toolTipText='Enter OME Meet' /></button>}
          </Fragment>}
      </td>
    </tr>
  )
};

const LargeDetailTable = ({ teamEntryMeetInfo, orgUnitOmeMeetEntry, onView, onEdit, onDeleteTeamEntryClicked, onAdd }) => {
  return (
    <table className={global.DetailTable}>
      <thead>
        <tr>
          <th>OME Meet Name</th>
          <th style={{ minWidth: '305px' }}>Entry Start - End Dates</th>
          <th style={{ minWidth: '180px' }}>Time Zone</th>
          <th style={{ minWidth: '130px' }}>Team Entry Status</th>
          <th style={{ minWidth: '100px' }}></th>
        </tr>
      </thead>
      <tbody>
        {Array.isArray(orgUnitOmeMeetEntry) && orgUnitOmeMeetEntry.length > 0 &&
          orgUnitOmeMeetEntry.map((teamEntry, i) =>
            <LargeDetailTableRow
              key={i}
              teamEntryMeetInfo={teamEntryMeetInfo}
              teamEntry={teamEntry}
              onView={onView}
              onEdit={onEdit}
              onDeleteTeamEntryClicked={onDeleteTeamEntryClicked}
              onAdd={onAdd}
            />)}
      </tbody>
    </table>
  );
};


const GridRow = ({ teamEntry, onEdit, onDeleteTeamEntryClicked, onView, onAdd }) => {
  return (
    <Fragment>
      <tr>
        <td>{teamEntry.orgUnitName || ''} {teamEntry.orgUnitName === 'Unattached' ? (teamEntry.parentOrgUnitName ? '- ' + teamEntry.parentOrgUnitName : '') : ''} {teamEntry?.parentOrgUnitCode ? '(' + teamEntry?.parentOrgUnitCode + ')' : ''}</td>
      </tr>
      {
        Array.isArray(teamEntry?.orgUnitOmeMeetEntry) && teamEntry?.orgUnitOmeMeetEntry?.length > 0 &&
        <tr className={global.Expanded}>
          <td colSpan="4">
            <LargeDetailTable
              teamEntryMeetInfo={teamEntry}
              orgUnitOmeMeetEntry={teamEntry?.orgUnitOmeMeetEntry}
              onView={onView}
              onEdit={onEdit}
              onDeleteTeamEntryClicked={onDeleteTeamEntryClicked}
              onAdd={onAdd}
            />
          </td>
        </tr>
      }
    </Fragment >
  );
};

const MeetTeamEntryLargeGrid = ({ gridData, isLoading, onAddEntryClicked, onEdit, onDeleteTeamEntryClicked, onView }) => (
  <Fragment>
    <table className={[global.UsasTable, 'visible-md visible-lg'].join(' ')}>
      <thead>
        <tr>
          <th>Team Name</th>
        </tr>
      </thead>
      <tbody>
        {isLoading === true ?
          <tr><td colSpan="1">Loading...</td></tr>
          : Array.isArray(gridData) && gridData.length > 0 ?
            gridData.map((teamEntry, i) =>
              <GridRow
                key={i}
                teamEntry={teamEntry}
                onEdit={onEdit}
                onDeleteTeamEntryClicked={onDeleteTeamEntryClicked}
                onView={onView}
                onAdd={onAddEntryClicked} />)
            :
            <tr>
              <td colSpan={1}>No Team Entries</td>
            </tr>
        }
      </tbody>
    </table>
  </Fragment>
);

export default MeetTeamEntryLargeGrid;